<div class="position-in-route-editor">
  <div class="row">
    <mat-form-field class="mat-form-field-readonly flex-grow" appearance="fill">
      <mat-label>
        <sc-dictionary-label
          dictionaryKey="tmc-yard.ui.admin.filter-administration.details-editor.transport.position-in-route-editor.position-in-route"></sc-dictionary-label>
      </mat-label>
      <input matInput [(ngModel)]="positionName" [readonly]="true">
      <sc-action-icon matSuffix (click)="assignNextProcessingPosition()" iconClass="fa-sitemap"></sc-action-icon>
    </mat-form-field>

  </div>
</div>
